import { fetchQuery, graphql } from "relay-runtime"
import {
  betterDocRemoteRecommendationQuery,
  betterDocRemoteRecommendationQuery$data,
} from "@/modules/admin/better-doc/services/__generated__/betterDocRemoteRecommendationQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query betterDocRemoteRecommendationQuery($recommendationId: String!) {
    de_betterDocRemoteRecommendation(recommendationId: $recommendationId) {
      status
      httpStatusCode
      errorReason
      exchangeId
      recommendation {
        recommendationId
        state
        caseId
        reason
        timeFrameStartingAt
        timeFrameEndingAt
        selectionType
        selectionId
        recommendationType
        secondOpinionVisitConfirmedByPatientAt
        secondOpinionVisitConfirmedAt
        insertedAt
        updatedAt
        partnerPatientId
        partnerSessionId
        localSessionId
        medics {
          name
          medhubId
          gender
          glnNumber
          zsrNumber
          travelTimeCar
          selectionType
          selectionId
          workplace {
            name
            ancestorName
            address
            postalCode
            city
            countryCode
          }
        }
      }
    }
  }
`

export type BetterDocRemoteRecommendationResult =
  betterDocRemoteRecommendationQuery$data["de_betterDocRemoteRecommendation"]

export type BetterDocRemoteRecommendation = NonNullable<BetterDocRemoteRecommendationResult["recommendation"]>

export type BetterDocRemoteMedic = BetterDocRemoteRecommendation["medics"][number]

export const fetchBetterDocRemoteRecommendation = (
  recommendationId: string,
): Promise<BetterDocRemoteRecommendationResult> =>
  fetchQuery<betterDocRemoteRecommendationQuery>(
    RelayEnvironment,
    query,
    { recommendationId },
    { fetchPolicy: "network-only" },
  )
    .toPromise()
    .then((response) => {
      if (!response) {
        throw new Error("BetterDoc returned no response")
      }

      return response.de_betterDocRemoteRecommendation
    })
